import * as apiConstants from '~/data/constants/api';

export const reset = () => async (dispatch) => {
  dispatch({
    type: apiConstants.RESET,
  });
};
